export const LOAD_BATCH_KPI_EVOLUTION_WIDGET_VALUES = "[DASHBOARD] LOAD_BATCH_KPI_EVOLUTION_WIDGET_VALUES";